module.exports = __webpack_public_path__ + "img/melvid-contas.9568b0ce.png";